import styled from 'styled-components';
import { rem } from 'polished';

const StyledHeadline = styled.h2`
  font-size: ${rem('26px')};
  line-height: ${rem('28px')};
  text-transform: uppercase;
  color: ${props => props.theme.colors.dark};
`;

export { StyledHeadline };
